export default __webpack_public_path__ + "static/media/ai_trading_1.e8d8ff63.png";